import React from "react"
import { useLocation } from "react-router-dom"
import Loading from "../../views/Loading"
import CarrotClient from "carrot-api/index"
import Settings from "../../../utils/CarrotConfig"

const ServicesLoginContainer = () => {
  const urlSearchParams = new URLSearchParams(useLocation().search)
  const RETURN_TO = "return_to"
  const returnToUrl = urlSearchParams.get(RETURN_TO)

  const client = new CarrotClient(Settings.CARROT_BACKEND_URL)

  client.getSupportCenterUrl().then((supportCenterUrl) => {
    const fullSupportCenterUrl = `${supportCenterUrl}&${RETURN_TO}=${returnToUrl}`
    window.location.href = fullSupportCenterUrl
  })

  return <Loading />
}

export { ServicesLoginContainer }
